(function (jQuery, Drupal) {

  var once = true;
  Drupal.behaviors.paragraph_video = {
    attach: function (context, settings) {
      if (once) {

        window.onYouTubeIframeAPIReady = function () {
          jQuery('.paragraph--type--video').each(function (index, element) {
            var $element = jQuery(element);
            var $player = $element.find('.player');

            var player = new YT.Player($player.attr('id'), {
              videoId: $player.attr('data-videoId'),
            });
            $element.find('.field--name-field-thumbnail')
              .click(function (event) {
                $element.find('.field--name-field-thumbnail').hide();
                player.playVideo();
              });
          });
        };

        if (jQuery('.paragraph--type--video').length > 0) {
          var tag = document.createElement('script');

          tag.src = "https://www.youtube.com/iframe_api";
          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
      }
    }
  }
})(jQuery, Drupal);
